<template>
      <section class="form">
              <b-container>
                <div id="v-step-0">A DOM element on your page. The first step will pop on this element because its ID is 'v-step-0'.</div>
                <div class="v-step-1">A DOM element on your page. The second step will pop on this element because its ID is 'v-step-1'.</div>
                <div data-v-step="2">A DOM element on your page. The third and final step will pop on this element because its ID is 'v-step-2'.</div>
                <v-tour name="myTour" :steps="steps"></v-tour>
              </b-container>
                    <!-- VueTour Help Icon -->
      <VueTour/>
      </section>
</template>

<script>
  import VueTour from "@/components/VueTour";

  export default {
    name: 'my-tour',
    components: {
      VueTour
    },
    data () {
      return {
        steps: [
          {
            target: '#v-step-0',
            content: `Discover <strong>Vue Tour</strong>!`
          },
          {
            target: '.v-step-1',
            content: 'An awesome plugin made with Vue.js!'
          },
          {
            target: '[data-v-step="2"]',
            content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
            params: {
              placement: 'top'
            }
          }
        ]
      }
    },
};
</script>

<style lang="scss">
  .page-header {
    display: flex;
    width: 100%;
    align-content: space-between;
    text-align: left;
  }
  .page-title {
    width: 100%;
    font-size: 1.75rem;
    line-height: 54px;
    font-weight: 500;
    text-transform: uppercase;
    background: #ccc;
    left: 0px;
    height: 54px;
    padding-left: 10px;
  }
</style>